// utils/errorHandling/log.ts - utils/errorHandling.ts split (sub-module log)

import { logger } from '../logger';

import type {StructuredErrorLog} from './types.js';


export const logStructuredError = (message: string, error?: Error | null, context?: Partial<StructuredErrorLog['context']>, metadata?: Record<string, any>): void => {
  const log: StructuredErrorLog = {
    timestamp: new Date().toISOString(),
    level: 'error',
    context: { page: window.location.pathname + window.location.search, ...context },
    error: { message, code: error?.name, stack: error?.stack },
    metadata,
  };
  logger.error(JSON.stringify(log));
};
